/**
 * `#knowledge` — `template.html` dòng 947–973.
 *
 * Section này KHÔNG có lead: khối đầu chỉ có eyebrow + h2 (:949-952). Đừng thêm.
 *
 * Hai card có hai kiểu hàng khác nhau: card trái dùng huy hiệu loại file có tint (:957-959),
 * card phải dùng icon (:965-967). `kind` khai union tại nguồn để chỗ dùng khỏi ép kiểu.
 */

interface BadgeRow {
  readonly kind: 'badge';
  readonly code: string;
  readonly tint: 'danger' | 'success' | 'brand';
  readonly label: string;
  readonly trailing: string;
}

interface IconRow {
  readonly kind: 'icon';
  readonly label: string;
  readonly trailing: string;
}

interface KnowledgeCard {
  readonly icon: 'library' | 'book-open';
  readonly iconTone: 'brand' | 'violet';
  readonly title: string;
  readonly beta: boolean;
  readonly body: string;
  readonly rows: readonly (BadgeRow | IconRow)[];
}

const cards: readonly KnowledgeCard[] = [
  {
    icon: 'library',
    iconTone: 'brand',
    title: 'Knowledge Base',
    beta: false,
    body: 'Thư viện tài liệu phân loại theo danh mục cho những gì công ty thực sự dùng lại — tìm được, đánh dấu được, và agent bạn cho phép cũng đọc được.',
    rows: [
      { kind: 'badge', code: 'PDF', tint: 'danger', label: 'launch-plan.pdf', trailing: '2.4 MB' },
      { kind: 'badge', code: 'XLSX', tint: 'success', label: 'qa-signoff.xlsx', trailing: '88 KB' },
      {
        kind: 'badge',
        code: 'DOCX',
        tint: 'brand',
        label: 'rollout-runbook.docx',
        trailing: '210 KB',
      },
    ],
  },
  {
    icon: 'book-open',
    iconTone: 'violet',
    title: 'Wiki',
    beta: true,
    body: 'Tài liệu nội bộ dạng dài với trình soạn thảo có cấu trúc — cẩm nang, runbook, biên bản quyết định sống lâu hơn cuộc chat.',
    rows: [
      { kind: 'icon', label: 'Cẩm nang kỹ thuật', trailing: 'v12' },
      { kind: 'icon', label: 'Runbook xử lý sự cố', trailing: 'v4' },
      { kind: 'icon', label: 'Biên bản quyết định Q2', trailing: 'v2' },
    ],
  },
];

export const knowledge = {
  eyebrow: 'Knowledge Base & Wiki',
  heading: 'Tri thức của đội nằm ngay nơi đội làm việc.',
  betaLabel: 'BETA',
  cards,
};
